module.exports = __webpack_public_path__ + "img/42f76be.jpg";